import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const ButtonGroup = (props) => {
  const { prevOnClick, nextOnClick } = props;
  return (
    <span className="relative z-0 inline-flex ">
      <button
        type="button"
        className="shadow-sm relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-100 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400"
        aria-label="Previous"
        onClick={prevOnClick}
      >
        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <button
        type="button"
        className="-ml-px shadow-sm relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-100 bg-white text-sm leading-5 font-medium text-gray-500 "
        aria-label="Next"
        onClick={nextOnClick}
      >
        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </span>
  );
};

export const buttonGroupControls = {
  prevOnClick: {
    propType: PropTypes.func.isRequired,
    description: "Handler for previous button click",
    disable: true,
  },
  nextOnClick: {
    propType: PropTypes.func.isRequired,
    description: "Handler for next button click",
    disable: true,
  },
};

ButtonGroup.propTypes = AppUtils.getPropTypeFromControls(buttonGroupControls);

export default ButtonGroup;
